<template>
  <div class="cmpnt-box">
    <!-- <header class="lmy-search-header">
        <i class="iconfont icon-back" @click="cancel"></i>
        <div class="lmy-input-box lmy-input-city-key">
              <i class="iconfont icon-search"></i>
              <input type="text" placeholder="全球城市名称/拼音" v-model="key"/>
        </div>
    </header> -->
    <header class="lmy-search-header search-header">
	      <i class="iconfont icon-yuyin" @click="cancel"></i>
        <div class="search-text" style="margin-left:.2rem" >
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-sousuo"></use>
          </svg>
          <input type="text" placeholder="全球城市名称/拼音" v-model="key"/>
        </div>
	    </header>
    <div class="lmy-search-list" v-if="key">
        <div class="list-item" v-for="city in cityList" @click="select(city,city.F)">
            <!-- {{city.N||city.E}} -->
            <h2>{{city.N||''}}</h2>
            <h3>{{city.E||''}}</h3>
        </div>
    </div>
    <div v-if="!key">
      <ul class="lmy-city-menu">
        <li :class="data.from==1?'item active':'item' " @click="data.from=1;">国内</li>
        <li :class="data.from==0?'item active':'item' " @click="data.from=0;">国际</li>
      </ul>
      <div class="lmy-city-content">
        <ul class="aside-bar">
          <li class="title">定位热门</li>
          <li @click="autoCityComplete(data.from==0?1:0,'A')">A</li>
          <li @click="autoCityComplete(data.from==0?1:0,'B')">B</li>
          <li @click="autoCityComplete(data.from==0?1:0,'C')">C</li>
          <li @click="autoCityComplete(data.from==0?1:0,'D')">D</li>
          <li @click="autoCityComplete(data.from==0?1:0,'E')">E</li>
          <li @click="autoCityComplete(data.from==0?1:0,'F')">F</li>
          <li @click="autoCityComplete(data.from==0?1:0,'G')">G</li>
          <li @click="autoCityComplete(data.from==0?1:0,'H')">H</li>
          <li @click="autoCityComplete(data.from==0?1:0,'I')">I</li>
          <li @click="autoCityComplete(data.from==0?1:0,'J')">J</li>
          <li @click="autoCityComplete(data.from==0?1:0,'K')">K</li>
          <li @click="autoCityComplete(data.from==0?1:0,'L')">L</li>
          <li @click="autoCityComplete(data.from==0?1:0,'M')">M</li>
          <li @click="autoCityComplete(data.from==0?1:0,'N')">N</li>
          <li @click="autoCityComplete(data.from==0?1:0,'O')">O</li>
          <li @click="autoCityComplete(data.from==0?1:0,'P')">P</li>
          <li @click="autoCityComplete(data.from==0?1:0,'Q')">Q</li>
          <li @click="autoCityComplete(data.from==0?1:0,'R')">R</li>
          <li @click="autoCityComplete(data.from==0?1:0,'S')">S</li>
          <li @click="autoCityComplete(data.from==0?1:0,'T')">T</li>
          <li @click="autoCityComplete(data.from==0?1:0,'U')">U</li>
          <li @click="autoCityComplete(data.from==0?1:0,'V')">V</li>
          <li @click="autoCityComplete(data.from==0?1:0,'W')">W</li>
          <li @click="autoCityComplete(data.from==0?1:0,'X')">X</li>
          <li @click="autoCityComplete(data.from==0?1:0,'Y')">Y</li>
          <li @click="autoCityComplete(data.from==0?1:0,'Z')">Z</li>
        </ul>
        <p class="hot-city">城市定位</p>
        <table class="hot-city-table">
          <tr>
            <td @click="select({S:data.myCityName,I:data.MyCityRegionID},1)"><i class="iconfont icon-location"></i>
              {{data.myCityName}}
            </td>
            <td @click="reSetLocation">我的位置</td>
            <td class="empty"></td>
          </tr>
        </table>
        <!-- 国内 -->
        <p class="hot-city">热门城市</p>
        <div v-if="data.from==1">

          <table class="hot-city-table">
            <tr v-for="item in cnCityList">
              <td v-for="city in item" @click="select(city,1)">{{city.S}}</td>
            </tr>

          </table>
          <div v-for="(item,key) in cnList" class="hot-city-character">
            <p class="city-frist" @click="autoCityComplete(0,key)">{{key}}</p>
            <ul class="city-list" v-if="item&&item.length>0">
              <li v-for="city in item" @click="select(city,1)">
               
                <h2>{{city.N||''}}</h2>
                <h3>{{city.E||''}}</h3>
              </li>
            </ul>
          </div>
        </div>


        <!-- 海外 -->
        <div v-if="data.from==0">
          <div v-for="area in frCityList">
            <p class="hot-city">{{area.S}}</p>
            <table class="hot-city-table">
              <tr v-for="item in area.list">
                <td v-for="city in item" @click="select(city,0)">{{city.S}}</td>

              </tr>

            </table>
          </div>

          <div v-for="(item,key) in frList" class="hot-city-character">
            <p class="city-frist" @click="autoCityComplete(1,key)">{{key}}</p>
            <ul class="city-list" v-if="item&&item.length>0">
              <li v-for="city in item" @click="select(city,0)">
                <h2>{{city.N||''}}</h2>
                <h3>{{city.E||''}}</h3>
              </li>
            </ul>
          </div>


        </div>

      </div>
    </div>
    <div class="character-alert" v-if="isLoadingData">{{character}}</div>
  </div>
</template>
<script>
  import cityList from './../city.js';

  export default {
    name: 'city',
    props: {
      cityData: {
        type: Object,
        default: () => {
          return {}
        }
      }

    },
    data() {
      return {
        data: {},
        key:'',
        cityList:'',
        character:"",
        isLoadingData:false,
        cnCityList: cityList.cnCity,
        frCityList: cityList.frCity,
        cnList: {
          A: [],
          B: [],
          C: [],
          D: [],
          E: [],
          F: [],
          G: [],
          H: [],
          I: [],
          J: [],
          K: [],
          L: [],
          M: [],
          N: [],
          O: [],
          P: [],
          Q: [],
          R: [],
          S: [],
          T: [],
          U: [],
          V: [],
          W: [],
          X: [],
          Y: [],
          Z: []
        },
        frList: {
          A: [],
          B: [],
          C: [],
          D: [],
          E: [],
          F: [],
          G: [],
          H: [],
          I: [],
          J: [],
          K: [],
          L: [],
          M: [],
          N: [],
          O: [],
          P: [],
          Q: [],
          R: [],
          S: [],
          T: [],
          U: [],
          V: [],
          W: [],
          X: [],
          Y: [],
          Z: [],
        }
      }
    },
    watch: {
      cityData(val) {
        this.data = val;
      },
      data:{
        handler:function(val,oldval){
          document.getElementsByClassName('cmpnt-box')[0].scrollTop = 0;
        },
        deep:true//对象内部的属性监听，也叫深度监听
      },

      key(val){
          if(!val)return;
          var that=this;
          that.cityList=[];
          var param={
              't':2,
              'q':val,
              'page':1,
          };

          if(val){
              this.getRequest({
                  url:that.Api.autoCityComplete,
                  params:param
              }).then(res => {
                  if(res&&res.Total>0){
                      that.cityList=res.Result;
                  }
              });
          }


       }
    },
    methods: {
      cancel() {
        this.key='';
        this.cityList='';

        this.$emit('select',{I:'',S:''})
      },
      select(item,from) {
        this.key='';
        this.cityList='';
        // if(item.S==this.data.myCityName){
        //   this.data.from=1;

        // }
        // this.data.from=item.F;

        this.$emit('select', item, from)
      },
      letterPosition(fl){
        var letter = document.getElementsByClassName('city-frist');
        var lheader = document.getElementsByClassName('lmy-search-header');
        var lmenu = document.getElementsByClassName('lmy-city-menu');
        for (let i = 0; i < letter.length; i++){
          if (letter[i].innerHTML == fl) {
            clearTimeout(t)
            var t = setTimeout(function () {
              document.getElementsByClassName('cmpnt-box')[0].scrollTop = letter[i].offsetTop - lheader[0].offsetHeight - lmenu[0].offsetHeight;
            },50);
            break;
          }
        }
      },

      autoCityComplete(t, fl) {
        var that = this;
        //如何已经加载则不再请求
        if ((that.cnList[fl] && that.cnList[fl].length > 0 && that.from == 1) || (that.frList[fl] && that.frList[fl].length > 0 && that.from == 0)) {
          return;
        }

        var params = {
          t: t,
          fl: fl,
          pageSize: 100,
        }
        that.isLoadingData=true;
        that.character=fl;
        that.getRequest({
          url: that.Api.autoCityComplete,
          params: params
        }).then(res => {
           that.isLoadingData=false;
          if (res && res.IsSuccess) {
            if (that.data.from == 1) {
              that.cnList[fl] = res.Result;
            } else {
              that.frList[fl] = res.Result;
            }
            that.letterPosition(fl);
          }
        });
      },
      initList() {
        //国内
        var resultcn = [];
        for (var i = 0, len = this.cnCityList.length; i < len; i += 3) {
          resultcn.push(this.cnCityList.slice(i, i + 3));
        }
        this.cnCityList = resultcn;
        // 海外
        var resultfr = [];
        for (var j = 0; j < this.frCityList.length; j++) {
          var resultfrTemp = [];
          for (var i = 0, len = this.frCityList[j].Items.length; i < len; i += 3) {
            resultfrTemp.push(this.frCityList[j].Items.slice(i, i + 3));
          }
          resultfr.push({S: this.frCityList[j].S, list: resultfrTemp});
        }
        this.frCityList = resultfr;
      },
      reSetLocation(){
          this.data.from=1;

          this.$emit('reSetLocation')
      }
    },
    mounted() {
      console.log(this.cityData)
      this.data = this.cityData;
      this.initList();
      this.autoCityComplete(this.data.from == 0 ? 1 : 0, 'A');
    },
  }


</script>



// WEBPACK FOOTER //
// src/components/common/cmpnt/city.vue